var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path10, _path11, _rect2, _path12, _path13, _ellipse, _circle2, _rect3, _path14, _path15, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path16, _path17, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCreateLiveSuccess = function SvgCreateLiveSuccess(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 201 200",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#create_live_success_svg__a)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 100,
    r: 100,
    fill: "#FAFBFF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M112.76 53.966c5.393-3.41 7.005-10.565 3.6-15.98s-10.537-7.04-15.93-3.63L69.411 53.97c-3.959 2.504-5.88 7.025-5.275 11.394l-6.403 4.049a4 4 0 0 0-.393.248l-2.677 1.693a4.78 4.78 0 0 0-1.483 6.58 4.75 4.75 0 0 0 5.96 1.817l4.807 7.646-.638.403a4.013 4.013 0 0 0-1.252 5.524l2.99 4.756 8.04-5.084v.001l14.936-9.445-2.99-4.755a3.99 3.99 0 0 0-5.51-1.249l-7.962 5.035-.042.026-.036.022-.64.404-4.781-7.604 3.149-1.991c3.671 2.433 8.57 2.645 12.53.14zm46.514 24.523c6.51 10.352 7.558 21.417 4.162 23.564l-6.13 3.875-.019.012-6.187 3.912-.039.025-6.906 4.366a4.014 4.014 0 0 1-1.622 4.772l-65.621 41.497-.087.053-7.953 5.029a3.987 3.987 0 0 1-5.51-1.248l-24.997-39.758a4.01 4.01 0 0 1 1.252-5.524l57.581-36.413.03-.018.04-.024.084-.05 19.65-12.427a3.99 3.99 0 0 1 5.51 1.249l1.869 2.972 1.46-.922 7.871-4.977 6.149-3.887c3.396-2.147 12.903 3.57 19.413 13.922M58.057 107.381l8.04-5.083L97.236 82.61v.001l13.776-8.71a1.79 1.79 0 0 0-2.474-.56l-10.395 6.572a3.99 3.99 0 0 0-4.31-.027l-7.995 5.055-.045.028-26.55 16.786a4.01 4.01 0 0 0-1.25 5.524z",
    clipRule: "evenodd",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191B1F",
    d: "M167.164 96.429c3.399-2.15 2.356-13.215-4.152-23.564-6.507-10.35-16.014-16.063-19.413-13.914l-6.154 3.89 23.566 37.479z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#32363B",
    d: "M161.019 100.315c4.35-2.75 2.601-13.37-3.906-23.72-6.507-10.348-15.308-16.508-19.658-13.757l-7.877 4.98 23.565 37.478z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E33",
    d: "M154.79 104.25c3.985-2.52 1.94-12.952-4.567-23.301-6.507-10.35-15.013-16.696-18.998-14.177l-7.553 4.777 23.565 37.477z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1F",
    fillRule: "evenodd",
    d: "M120.094 32.365c3.405 5.415 1.793 12.569-3.601 15.98L85.474 67.958c-5.393 3.41-12.525 1.786-15.93-3.629s-1.792-12.569 3.601-15.98l31.019-19.614c5.394-3.41 12.526-1.786 15.93 3.629",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    fillRule: "evenodd",
    d: "M61.269 63.911a4.073 4.073 0 0 1 5.626 1.282l10.609 16.873a4.1 4.1 0 0 1-1.272 5.643 4.073 4.073 0 0 1-5.625-1.282l-10.61-16.873a4.1 4.1 0 0 1 1.272-5.643",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    fillRule: "evenodd",
    d: "M79.89 57.785a4.78 4.78 0 0 1-1.483 6.58l-14.935 9.444a4.75 4.75 0 0 1-6.559-1.495 4.78 4.78 0 0 1 1.483-6.58l14.935-9.443a4.75 4.75 0 0 1 6.559 1.494",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#191B1F",
    d: "M69.77 96.576a4.01 4.01 0 0 1 1.252-5.524l26.55-16.787a3.99 3.99 0 0 1 5.509 1.249l.064.102-33.311 21.061zM73.832 82.62a4.013 4.013 0 0 1 1.252-5.523l8.175-5.17a3.99 3.99 0 0 1 5.51 1.248l2.99 4.756-14.937 9.445z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#create_live_success_svg__b)",
    d: "M50.145 113.89a4.01 4.01 0 0 1 1.251-5.524l69.348-43.854a3.99 3.99 0 0 1 5.51 1.249l3.042 4.839a31.1 31.1 0 0 1 4.252 10.9 31.1 31.1 0 0 0 4.251 10.901l9.725 15.468a4.01 4.01 0 0 1-1.251 5.524l-65.624 41.499a3.99 3.99 0 0 1-5.51-1.249z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76.132,
    height: 54.96,
    fill: "#464B52",
    rx: 4,
    transform: "rotate(-32.308 219.505 -11.214)skewX(-.15)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#32363B",
    d: "M61.73 101.66a4.01 4.01 0 0 1 1.253-5.524l26.549-16.787a3.99 3.99 0 0 1 5.51 1.249l.064.102-33.311 21.061z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    d: "M65.793 87.705a4.01 4.01 0 0 1 1.252-5.525l8.175-5.169a3.987 3.987 0 0 1 5.51 1.248l2.99 4.756-14.937 9.445z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#32363B",
    d: "M100.971 76.99a1.8 1.8 0 0 1 .562-2.479l10.741-6.79a1.79 1.79 0 0 1 2.473.56z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 51.664,
    height: 46.719,
    fill: "#32363B",
    rx: 1.333,
    transform: "rotate(-32.309 216.43 -48.442)skewX(-.15)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1F",
    d: "m61.11 108.793 41.756-26.406 23.328 37.104-41.756 26.406z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#32363B",
    stroke: "#191C1F",
    strokeWidth: 1.333,
    d: "M66.58 138.722c3.807-2.408 4.92-7.477 2.506-11.316s-7.454-5.017-11.261-2.61c-3.808 2.408-4.92 7.476-2.506 11.316s7.454 5.017 11.26 2.61Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.399,
    cy: 3.435,
    fill: "#191C1F",
    rx: 3.399,
    ry: 3.435,
    transform: "rotate(-32.309 254.303 -33.92)skewX(-.15)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.165,
    cy: 1.165,
    r: 1.165,
    fill: "#D6342C",
    transform: "rotate(-32.309 220.238 -57.147)skewX(-.15)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.657,
    height: 1.164,
    fill: "#1BEE74",
    rx: 0.582,
    transform: "rotate(-32.306 300.29 -51.838)skewX(-.145)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6342C",
    d: "m119.742 74.031 8.364-5.288.93 1.478-8.364 5.289z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#191B1F",
    d: "m142.017 108.193 4.07-2.573-7.365-15.245a17.3 17.3 0 0 1-1.232-3.428l-.597-2.439a18.7 18.7 0 0 0-2.332-5.509l-5.519-8.777-8.369 5.291a18.5 18.5 0 0 1 2.466 6.255c.829 4.165 1.376 8.61 3.634 12.202l7.897 12.559a5.317 5.317 0 0 0 7.347 1.664"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#212326",
    rx: 1.165,
    transform: "rotate(-32.307 282.475 -38.017)skewX(-.147)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#212326",
    rx: 1.165,
    transform: "rotate(-32.307 224.097 -21.262)skewX(-.147)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#32363B",
    rx: 1.165,
    transform: "rotate(-32.307 283.058 -36.006)skewX(-.147)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#32363B",
    rx: 1.165,
    transform: "rotate(-32.307 224.68 -19.25)skewX(-.147)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#212326",
    rx: 1.165,
    transform: "rotate(-32.307 292.543 -40.904)skewX(-.147)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#32363B",
    rx: 1.165,
    transform: "rotate(-32.307 293.123 -38.894)skewX(-.147)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#212326",
    rx: 1.165,
    transform: "rotate(-32.307 278.4 -52.075)skewX(-.147)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#212326",
    rx: 1.165,
    transform: "rotate(-32.307 220.022 -35.32)skewX(-.147)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#32363B",
    rx: 1.165,
    transform: "rotate(-32.307 278.983 -50.064)skewX(-.147)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#32363B",
    rx: 1.165,
    transform: "rotate(-32.307 220.606 -33.324)skewX(-.147)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#212326",
    rx: 1.165,
    transform: "rotate(-32.307 288.465 -54.963)skewX(-.147)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#32363B",
    rx: 1.165,
    transform: "rotate(-32.307 289.048 -52.952)skewX(-.147)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 15.135,
    height: 3.493,
    fill: "#191C1F",
    rx: 1.333,
    transform: "rotate(-32.305 235.344 -20.135)skewX(-.142)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 12.805,
    height: 1.164,
    fill: "#32363B",
    rx: 0.582,
    transform: "rotate(-32.304 236.78 -22.721)skewX(-.14)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#282C31",
    d: "m49.773 122.396.985-.623.62.987-.985.622zM51.742 121.152l.985-.623.62.987-.985.622zM53.71 119.908l.986-.623.62.987-.985.622zM55.68 118.664l.984-.623.62.987-.984.622zM57.648 117.42l.985-.623.62.987-.985.622z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#0FC75E",
    d: "M149.193 166.715c15.109 0 27.358-12.249 27.358-27.358S164.302 112 149.193 112s-27.357 12.248-27.357 27.357 12.248 27.358 27.357 27.358"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.405 37.291c0 .614.497 1.112 1.11 1.112h1.843c.54.005.98-.435.98-.98l-.006-6.053 6.018-.006c.539.005.979-.435.979-.98v-1.958a.974.974 0 0 0-.98-.979h-6.021l-.006-5.98a.974.974 0 0 0-.98-.979h-1.958a.974.974 0 0 0-.98.98v5.979h-5.878c-.614 0-1.112.497-1.112 1.111v1.843c-.005.539.435.979.98.979l6.01-.006zM136.843 140.202a1.26 1.26 0 0 1 0-1.794l1.794-1.793a1.26 1.26 0 0 1 1.793 0l5.564 5.563 11.923-11.923a1.26 1.26 0 0 1 1.794 0l1.794 1.794a1.26 1.26 0 0 1 0 1.793l-14.6 14.629a1.26 1.26 0 0 1-1.794 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "create_live_success_svg__b",
    x1: 86.07,
    x2: 115.443,
    y1: 86.439,
    y2: 132.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32363B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "create_live_success_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    x: 0.5,
    fill: "#fff",
    rx: 100
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCreateLiveSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "create_live_success.svg";